<ion-item>
  <ion-icon slot="start" size="large" src="assets/icons/unit-resources/resource-fire-fighter.svg"></ion-icon>
  <ion-label>{{ 'Mobile.ResourceCount' | translate }}: {{ resourceCount }}</ion-label>
</ion-item>
